import React from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const stepPaths = [
    '/step-1',
    '/step-2',
    '/step-3',
    '/step-4',
    '/step-5',
    '/step-6',
    '/step-7',
    '/step-8',
    '/step-9',
    '/step-10',
    '/step-11',
    '/patient-report',
    // '/summary'
];

const ProgressBar = () => {
    const location = useLocation();
    
    // 1. Identify where we are
    const currentPath = location.pathname;
    
    // 2. Find the index (0 for step-1, 1 for step-2, etc.)
    const currentIndex = stepPaths.indexOf(currentPath);
    
    // 3. Calculate Percentage
    // Total steps to complete (excluding summary for the denominator to hit 100% at step 10 if desired, 
    // or include it. Here we treat step 10 as 100% logic usually)
    let progress = 0;

    if (currentPath === '/' || currentPath === '/introduction') {
        progress = 0;
    } else if (currentIndex !== -1) {
        // Calculate progress based on total numbered steps (11)
        // Step 1 ~ 9%, Step 6 ~ 55%, Step 11 = 100%
        const totalSteps = 11;
        const activeStep = currentIndex + 1;
        progress = Math.min(100, (activeStep / totalSteps) * 100);
    }

    // Hide on Introduction page if desired
    if (progress === 0 && currentPath !== '/step-1') {
        return null;
    }

    return (
        <div className="progress-bar-container">
            <div className="progress-track">
                <motion.div 
                    className="progress-fill"
                    initial={{ width: 0 }}
                    animate={{ width: `${progress}%` }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                />
            </div>
            {/* Optional: Text indicator */}
            <div className="progress-text">
                {currentPath === '/patient-report' ? (
                    <span>Complete</span>
                ) : (
                    <span>{Math.round(progress)}% Complete</span>
                )}
            </div>
        </div>
    );
};

export default ProgressBar;